// YouTube Data API v3 Configuration
// Get your API key from: https://console.cloud.google.com/
export const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY || '';
export const BASE_URL = 'https://www.googleapis.com/youtube/v3';

export const ENDPOINTS = {
  search: `${BASE_URL}/search`,
  videos: `${BASE_URL}/videos`,
  channels: `${BASE_URL}/channels`,
  commentThreads: `${BASE_URL}/commentThreads`,
  videoCategories: `${BASE_URL}/videoCategories`,
};
